import { setConfig } from '@sdk/config/appConfig';


const { REACT_APP_ENV = 'production' } = process.env;

export const IS_STAGING = REACT_APP_ENV === 'staging';
export const IS_PRODUCTION = REACT_APP_ENV === 'production';
export const IS_DEVELOPMENT = !IS_STAGING && !IS_PRODUCTION;

export function getAppUrl(subdomain = 'app') {
  let prefix = '';
  let protocol = 'https';

  if (IS_STAGING) {
    prefix = 'test-';
  } else if (IS_DEVELOPMENT) {
    prefix = 'local-';
    protocol = 'http';
  }

  return `${protocol}://${prefix}${subdomain}.getsling.com`;
}

const config = require(`./config.${REACT_APP_ENV}.js`).default;

setConfig({ 
  AUTH_COOKIE_NAME: config.AUTHORIZATION_COOKIE,
  API_ENDPOINT: config.API_URL,
})

export default config;
